import { Button, ConfigProvider, Modal } from "antd";
import {
  ModalHeader,
  modalButtonsTheme,
} from "components/modals/ModalChrome";
import { memo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";
import { Schedule } from "shared/types";
import {
  UpdateScheduleFormBody,
  UpdateScheduleFormBodyHandle,
} from "./UpdateScheduleFormBody";

interface UpdateScheduleModalProps {
  schedule: Schedule;
  disabled?: boolean;
}

const UpdateScheduleModal = memo(
  ({ schedule, disabled }: UpdateScheduleModalProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const bodyRef = useRef<UpdateScheduleFormBodyHandle>(null);
    const navigate = useNavigate();
    const [blocked, setBlocked] = useState(false);

    const handleClose = () => {
      setIsOpen(false);
      bodyRef.current?.reset();
    };

    return (
      // Popup button-color system: navy "Perbarui Jadwal" trigger + "Perbarui"
      // confirm, solid-ink "Batal" dismiss.
      <ConfigProvider theme={modalButtonsTheme}>
        <Button
          type="primary"
          disabled={disabled}
          onClick={() => setIsOpen(true)}
        >
          {translate("button.update")} {translate("schedule.name")}
        </Button>
        <Modal
          title={<ModalHeader title={translate("title.update_schedule")} />}
          open={isOpen}
          onCancel={handleClose}
          onOk={() => bodyRef.current?.submit()}
          okText={translate("button.update")}
          okButtonProps={{ disabled: blocked }}
          width={500}
        >
          <UpdateScheduleFormBody
            ref={bodyRef}
            schedule={schedule}
            enabled={isOpen}
            onBlockedChange={setBlocked}
            onUpdated={(nextScheduleId, nextTimestamp) => {
              handleClose();
              navigate(
                `${PATHS.SCHEDULE}/${nextScheduleId}?occurrence_timestamp=${encodeURIComponent(
                  nextTimestamp,
                )}`,
                { replace: true },
              );
            }}
          />
        </Modal>
      </ConfigProvider>
    );
  },
);

export default UpdateScheduleModal;
